<template>
  <div>
    <p v-if="showTitle" class="title">Raid</p>
    <div v-for="raid in raids" :key="raid.name">
      <span class="subtitle">{{raid.name}}</span>
      <template v-for="(line, i) in raid.lines">
        {{line}}<br :key="i"/>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    serverUrl: {
      type: String,
      default: ""
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      raids: []
    };
  },
  created() {
    setTimeout(() => {
      this.startMonitor();
    }, 1000);
  },
  methods: {
    startMonitor() {
      this.$http
        .get(this.serverUrl + "mdadm.php")
        .then(response => {
          this.raids = response.data;

          setTimeout(() => {
            this.startMonitor();
          }, 61000);
        })
        .catch(error => {
          setTimeout(() => {
            this.startMonitor();
          }, 1000);
        });
    }
  }
};
</script>

<style scoped>
.subtitle {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// app/monitor/src/components/MonitorMdadm.vue